import { apiClient } from './client';
import type { RequestOptions } from '@/types/api';
import type {
  HttpStatsQuery,
  HttpStatsSummary,
  HttpStatsTimeseries,
  StatsCollectorsResponse,
} from '@/types/stats';

/**
 * Query string of the summary/timeseries endpoints; the node filter is
 * omitted when empty.
 */
function queryParams({ range, node_id }: HttpStatsQuery): Record<string, string> {
  return node_id ? { range, node_id } : { range };
}

/**
 * Per-site HTTP status statistics
 */
export const statsApi = {
  /**
   * Totals and per-domain statistics for a range
   */
  async getSummary(query: HttpStatsQuery, options?: RequestOptions): Promise<HttpStatsSummary> {
    const response = await apiClient.get<HttpStatsSummary>('/stats/http/summary', {
      params: queryParams(query),
      signal: options?.signal,
    });
    return response.data;
  },

  /**
   * Requests over time and all statuses of one domain
   */
  async getTimeseries(
    domain: string,
    query: HttpStatsQuery,
    options?: RequestOptions
  ): Promise<HttpStatsTimeseries> {
    const response = await apiClient.get<HttpStatsTimeseries>('/stats/http/timeseries', {
      params: { domain, ...queryParams(query) },
      signal: options?.signal,
    });
    return response.data;
  },

  /**
   * Per-node collector state (last pull, errors, staleness)
   */
  async getCollectors(options?: RequestOptions): Promise<StatsCollectorsResponse> {
    const response = await apiClient.get<StatsCollectorsResponse>('/stats/http/collectors', {
      signal: options?.signal,
    });
    return response.data;
  },
};
